import {ParamsModel} from 'src/app/modules/common/Model'
import {actionTypes} from './constants'

export const actions = {
  getFixedDepositLeads: (params: ParamsModel = {page: 1, limit: 15}) => ({
    type: actionTypes.GET_FIXED_DEPOSIT_LEADS_START,
    payload: params,
  }),
  getFixedDepositLeadsSuccess: (data: any) => ({
    type: actionTypes.GET_FIXED_DEPOSIT_LEADS_SUCCESS,
    payload: data,
  }),
  getFixedDepositLeadsFinish: () => ({
    type: actionTypes.GET_FIXED_DEPOSIT_LEADS_FINISH,
  }),
}
